export default {
  "container": "_container_1qmui0",
  "subtitle": "_subtitle_1qmui0"
};
